"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckbox = exports.CheckboxBase = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const HelperText_1 = require("../components/HelperText");
const Css_1 = require("../Css");
const ErrorMessage_1 = require("./ErrorMessage");
const utils_1 = require("../utils");
const defaultTestId_1 = require("../utils/defaultTestId");
function CheckboxBase(props) {
    const { ariaProps, description, isDisabled = false, isIndeterminate = false, inputProps, label, errorMsg, helperText, checkboxOnly = false, withLabelElement = true, } = props;
    const ref = (0, react_1.useRef)(null);
    const { isFocusVisible, focusProps } = (0, react_aria_1.useFocusRing)(ariaProps);
    const tid = (0, utils_1.useTestIds)(props, (0, defaultTestId_1.defaultTestId)(label));
    const Tag = withLabelElement ? "label" : "div";
    return ((0, jsx_runtime_1.jsxs)(Tag, { css: Css_1.Css.df.cursorPointer.relative
            // Prevents accidental checkbox clicks due to label width being longer
            // than the content.
            .w("max-content")
            .maxw((0, Css_1.px)(320))
            .if(description !== undefined)
            .maxw((0, Css_1.px)(344))
            .if(isDisabled).cursorNotAllowed.$, "aria-label": label, children: [(0, jsx_runtime_1.jsx)(react_aria_1.VisuallyHidden, { children: (0, jsx_runtime_1.jsx)("input", { ref: ref, ...(0, react_aria_1.mergeProps)(inputProps, focusProps), ...tid, "data-indeterminate": isIndeterminate }) }), (0, jsx_runtime_1.jsx)(StyledCheckbox, { ...props, isFocusVisible: isFocusVisible, ...tid }), !checkboxOnly && (
            // Use a mtPx(-2) to better align the label with the checkbox.
            // Not using align-items: center as the checkbox would align with all content below, where we really want it to stay only aligned with the label
            (0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.ml1.mtPx(-2).$, children: [label && (0, jsx_runtime_1.jsx)("div", { css: { ...labelStyles, ...(isDisabled && disabledColor) }, children: label }), description && (0, jsx_runtime_1.jsx)("div", { css: { ...descStyles, ...(isDisabled && disabledColor) }, children: description }), errorMsg && (0, jsx_runtime_1.jsx)(ErrorMessage_1.ErrorMessage, { errorMsg: errorMsg, ...tid.errorMsg }), helperText && (0, jsx_runtime_1.jsx)(HelperText_1.HelperText, { helperText: helperText, ...tid.helperText })] }))] }));
}
exports.CheckboxBase = CheckboxBase;
const baseStyles = Css_1.Css.hPx(16).mw((0, Css_1.px)(16)).relative.ba.bcGray300.br4.bgWhite.transition.$;
const filledBoxStyles = Css_1.Css.bcBlue700.bgBlue700.$;
const filledBoxHoverStyles = Css_1.Css.bgBlue900.$;
const disabledBoxStyles = Css_1.Css.bgGray50.bcGray100.$;
const disabledSelectedBoxStyles = Css_1.Css.bgGray400.bcGray400.$;
const disabledColor = Css_1.Css.gray300.$;
const focusRingStyles = Css_1.Css.bshFocus.$;
const hoverBorderStyles = Css_1.Css.bcBlue900.$;
const markStyles = { svg: Css_1.Css.absolute.topPx(-1).leftPx(-1).$ };
const labelStyles = Css_1.Css.smMd.$;
const descStyles = Css_1.Css.sm.gray700.$;
function StyledCheckbox(props) {
    const { isDisabled = false, isIndeterminate = false, isSelected, isFocusVisible } = props;
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)({ isDisabled });
    const markIcon = isIndeterminate ? dashSmall : isSelected ? checkmarkSmall : "";
    const tid = (0, utils_1.useTestIds)(props);
    return ((0, jsx_runtime_1.jsx)("span", { ...hoverProps, css: {
            ...baseStyles,
            ...(((isSelected && !isDisabled) || isIndeterminate) && filledBoxStyles),
            ...(((isSelected && !isDisabled) || isIndeterminate) && isHovered && filledBoxHoverStyles),
            ...(isDisabled && disabledBoxStyles),
            ...(isDisabled && isSelected && disabledSelectedBoxStyles),
            ...(isFocusVisible && focusRingStyles),
            ...(isHovered && hoverBorderStyles),
            ...markStyles,
        }, "aria-hidden": "true", "data-checked": isSelected ? true : isIndeterminate ? "mixed" : false, ...tid.checkbox, children: markIcon }));
}
exports.StyledCheckbox = StyledCheckbox;
const checkmarkSmall = ((0, jsx_runtime_1.jsx)("svg", { width: "16", height: "16", children: (0, jsx_runtime_1.jsx)("path", { d: "M6.66669 10.3907L4.47135 8.19533L3.52869 9.138L6.66669 12.276L13.138 5.80467L12.1954 4.862L6.66669 10.3907Z", fill: Css_1.Palette.White }) }));
const dashSmall = ((0, jsx_runtime_1.jsx)("svg", { width: "16", height: "16", children: (0, jsx_runtime_1.jsx)("rect", { x: "4", y: "7.5", width: "8", height: "1.35", fill: Css_1.Palette.White }) }));
